import qs from "qs";
import axios from "axios";
import { URL, API_URL } from "../../../constants/Constants";

/**
 * Obtiene datos completos de MO (Manufacturing Order)
 * @param {string} type - Tipo de pantalla
 * @param {string} typeConnect - Tipo de conexión
 * @param {number} currentScreenId - ID de la pantalla actual
 * @returns {Promise<Array|false>} Datos de MO o false si no se encuentran
 */
export const getFullMo = async (type, typeConnect, currentScreenId) => {
  const queryData = {
    screen: type,
    action: typeConnect,
    query_type: currentScreenId,
  };

  try {
    const response = await axios.post(URL, qs.stringify(queryData));
    if (response.data.status === "ok") {
      return response.data.data;
    } else {
      console.log("Pieza no encontrada");
      return false;
    }
  } catch (error) {
    console.error("Error al enviar la conexión POST:", error);
    return false;
  }
};

/**
 * Obtiene datos completos de MO para mecanizado
 * @param {string} type - Tipo de pantalla
 * @param {string} typeConnect - Tipo de conexión
 * @param {number} currentScreenId - ID de la pantalla actual
 * @returns {Promise<Array|false>} Datos de MO o false si no se encuentran
 */
export const getFullMoForMachining = async (type, typeConnect, currentScreenId) => {
  const queryData = {
    screen: type,
    action: typeConnect,
    query_type: currentScreenId,
  };

  try {
    const response = await axios.post(URL, qs.stringify(queryData));
    if (response.data.status === "ok") {
      return response.data.data;
    } else {
      console.log("Pieza no encontrada");
      return false;
    }
  } catch (error) {
    console.error("Error al enviar la conexión POST:", error);
    return false;
  }
};

/**
 * Obtiene datos completos de MO para piedras
 * @param {string} type - Tipo de pantalla (mantenido por compatibilidad, no se usa)
 * @param {string} typeConnect - Tipo de conexión (mantenido por compatibilidad, no se usa)
 * @param {number} currentScreenId - ID de la pantalla actual (mantenido por compatibilidad, no se usa)
 * @returns {Promise<Array|false>} Datos de MO o false si no se encuentran
 */
export const getFullMoForStone = async (type, typeConnect, currentScreenId) => {
  const queryData = {
    screen: "stone_control",
    action: "query",
  };

  try {
    const response = await axios.post(API_URL, qs.stringify(queryData));
    if (response.data.status === "ok") {
      return response.data.data;
    } else {
      console.log("Pieza no encontrada");
      return false;
    }
  } catch (error) {
    console.error("Error al enviar la conexión POST:", error);
    return false;
  }
};

/**
 * Obtiene datos completos de MO que no son nulos
 * @param {string} type - Tipo de pantalla (mantenido por compatibilidad, no se usa)
 * @param {string} typeConnect - Tipo de conexión (mantenido por compatibilidad, no se usa)
 * @param {number} currentScreenId - ID de la pantalla actual (mantenido por compatibilidad, no se usa)
 * @returns {Promise<Array|false>} Datos de MO o false si no se encuentran
 */
export const getFullMoNotNull = async (type, typeConnect, currentScreenId) => {
  const queryData = {
    screen: "parts_movements",
    action: "query",
  };

  try {
    const response = await axios.post(API_URL, qs.stringify(queryData));
    if (response.data.status === "ok") {
      return response.data.data;
    } else {
      console.log("Pieza no encontrada");
      return false;
    }
  } catch (error) {
    console.error("Error al enviar la conexión POST:", error);
    return false;
  }
};

/**
 * Obtiene detalles de datos de MOs
 * @param {string} queryType - Tipo de consulta
 * @param {string} query_param - Parámetro de consulta
 * @param {Array} mos - Array de MOs
 * @returns {Promise<Object|false>} Datos de respuesta o false si hay error
 */
export const getDetalleDatosMos = async (queryType, query_param, mos) => {
  const queryData = {
    query_type: queryType,
    query_param: query_param,
    mos: mos,
  };

  try {
    const response = await axios.post(
      URL,
      qs.stringify(queryData, { arrayFormat: "brackets" }),
      {
        headers: { "Content-Type": "application/x-www-form-urlencoded" },
      }
    );

    if (response.data.status === "ok") {
      return response.data.data;
    } else {
      console.log("Pieza no encontrada");
      return false;
    }
  } catch (error) {
    console.error("Error al enviar la conexión POST:", error);
    return false;
  }
};

/**
 * Actualiza comentario agregado
 * @param {string} queryType - Tipo de consulta
 * @param {string} query_param - Parámetro de consulta
 * @param {string} comment - Comentario
 * @param {string} mo - Manufacturing Order
 * @returns {Promise<Object|false>} Datos de respuesta o false si hay error
 */
export const updateCommentAdded = async (queryType, query_param, comment, mo) => {
  const queryData = {
    query_type: queryType,
    query_param: query_param,
    data: comment,
    mo: mo,
  };

  try {
    const response = await axios.post(URL, qs.stringify(queryData));

    if (response.data.status === "ok") {
      return response.data.data;
    } else {
      console.log("Pieza no encontrada");
      return false;
    }
  } catch (error) {
    console.error("Error al enviar la conexión POST:", error);
    return false;
  }
};

/**
 * Obtiene lista de líneas de MO
 * @param {string} screenName - Nombre de la pantalla
 * @param {string} type - Tipo
 * @param {number} currentScreenId - ID de la pantalla actual
 * @param {string} po - Purchase Order
 * @param {string} mo - Manufacturing Order
 * @returns {Promise<Object|false>} Datos de respuesta o false si hay error
 */
export const getListMoLine = async (screenName, type, currentScreenId, po, mo) => {
  const queryData = {
    action: type,
    query_type: currentScreenId,
    query_param: screenName,
    po: po,
    mo: mo,
  };
  try {
    const response = await axios.post(URL, qs.stringify(queryData));
    if (response.data.status === "ok") {
      console.log("lista de procesos correcta");
      return response.data.data;
    } else {
      console.log("Error en la lista de procesos");
      return false;
    }
  } catch (error) {
    console.error("Error al enviar la conexión POST:", error);
    return false;
  }
};

/**
 * Actualiza término de MO
 * @param {number} currentScreenId - ID de la pantalla actual
 * @param {string} query_param - Parámetro de consulta
 * @param {string} mo - Manufacturing Order
 * @returns {Promise<Object|false>} Datos de respuesta o false si hay error
 */
export const updateTermMo = async (currentScreenId, query_param, mo) => {
  const queryData = {
    query_type: currentScreenId,
    query_param: query_param,
    mo: mo,
  };
  try {
    const response = await axios.post(URL, qs.stringify(queryData));
    if (response.data.status === "ok") {
      return response.data.data;
    } else {
      console.log("Pieza no encontrada");
      return false;
    }
  } catch (error) {
    console.error("Error al enviar la conexión POST:", error);
    return false;
  }
};

/**
 * Inserta movimientos de MO
 * @param {string} query_param - Parámetro de consulta
 * @param {string} queryType - Tipo de consulta
 * @param {string} data - Datos
 * @returns {Promise<Object|false>} Datos de respuesta o false si hay error
 */
export const insertMovimientosMo = async (query_param, queryType, data) => {
  const queryData = {
    query_param: query_param,
    query_type: queryType,
    data: data,
  };

  try {
    const response = await axios.post(URL, qs.stringify(queryData));

    if (response.data.status === "ok") {
      return response.data.data;
    } else {
      console.log("Movimiento no insertado");
      return false;
    }
  } catch (error) {
    console.error("Error al enviar la conexión POST:", error);
    return false;
  }
};
